export enum KpiMutationTypes {
  CLEAR_KPI_DATA = 'CLEAR_KPI_DATA',
  SET_KPI_DATA = 'SET_KPI_DATA',
  SET_GROUPED_KPI_DATA = 'SET_GROUPED_KPI_DATA',
  SET_GROUPED_KPI_DATA_LOADING = 'SET_GROUPED_KPI_DATA_LOADING',
  SET_KPI_DATA_LOADING = 'SET_KPI_DATA_LOADING',
}
